import { v4 as UUIDv4 } from 'uuid';

/**
 * Unique identifier for this browser tab or client instance.
 * Used to ignore realtime messages that originated from this client so mutating clients
 * do not double-invalidate TanStack Query caches.
 */
export const clientInstanceId = UUIDv4();

/**
 * Request header used to forward this client's instance id to the API so realtime
 * broadcasts can echo it back as `originatorClientId`, letting the originating client
 * skip invalidating caches it already updated locally.
 */
export const CLIENT_INSTANCE_HEADER = 'x-client-instance-id';
